<template lang="pug">
  b-col.text-right(xs='2' v-if='canCreate()')
    router-link.btn.btn-primary( :to="{ name: newEntityRouteName }") {{ newEntityBtn }}
</template>

<script>
  import Policeman from '@/utils/Policeman/policeman'

  export default {
    name: 'CreateEntity',
    props: {
      entity: {
        type: String,
        default: null
      },
      newEntityBtn: {
        type: String,
        default: ''
      },
      newEntityRouteName: {
        type: String,
        default: ''
      }
    },
    methods: {
      canCreate () {
        return Policeman.can('new', this.entity)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Shared/CreateEntity.vue